import axios from "axios";
import { buildAuthHeaders } from "../buildAuthHeaders";
import { rootUrl } from "../rootUrl";

export interface ScheduledMessage {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  campaignId: string;
  messageText: string;
  scheduledFor: Date;
  status: "PENDING" | "SENDING" | "SENT" | "FAILED";
  socialShareImage?: string | null;
  totalRecipients?: number | null;
  deliveredCount?: number | null;
  failedCount?: number | null;
  skippedCount?: number | null;
}

export const getCampaignScheduledMessages = async (
  accessToken: string,
  campaignId: string
): Promise<ScheduledMessage[]> => {
  const { data } = await axios.get<ScheduledMessage[]>(
    `${rootUrl}/client/campaigns/${campaignId}/scheduled-messages`,
    buildAuthHeaders(accessToken)
  );
  return data;
};
